<template lang="pug">
  .relative
    .carousel.h-100vh.overflow-hidden.fades.outline-none(ref="carousel", :style="'height:'+height+'px'", :class="{'opacity-0': loading}")
      .carousel-cell.w-100.h-100vh.relative(v-for="(slide, index) in slides", :style="'height:'+height+'px'")
        slide.overlay(:preload="index === 0", :images="slide.images", :format="slide.format", :portraitMode="portraitMode", @loaded="loading = false")
    transition(name="fade")
      slider-footer.absolute.z2.w-100.h-4.bottom-0.left-0(v-if="flkty", v-show="showFooter", :project="activeProject", :index="activeSlide.hmnIndex", :length="activeProjectImgCount", @click="thumbsVisible = true")
    transition(name="fade")
      thumbs-view.fixed.overlay.z3(v-show="thumbsVisible", :visible="thumbsVisible", :allImages="allImages", :activeProject="activeProject", @close="hideThumbsView", @thumbClick="jumpToSlideByImageSrc")
</template>

<script>
import Slide from '@/components/SeriesViewer__Slider__Slide'
import SliderFooter from '@/components/SeriesViewerFooter'
import ThumbsView from '@/components/SeriesViewer__ThumbsView'
import Flickity from 'flickity-bg-lazyload'
import _findIndex from 'lodash/findIndex'
import _find from 'lodash/find'
import { getSlides, getSlidesImages } from '@/components/helpers/slideUtils'
export default {
  name: 'Viewer__Slider',
  props: ['portraitMode', 'projects', 'selectedID', 'showFooter', 'limitToFirstPrj', 'height'],
  components: { Slide, SliderFooter, ThumbsView },
  data () {
    return {
      loading: true,
      flkty: null,
      thumbsVisible: false
      // height: window.innerHeight
    }
  },
  watch: {
    selectedID (id) {
      this.jumpToSlide(id)
    }
  },
  computed: {
    slides () {
      return getSlides(this.projects, this.portraitMode)
    },
    allImages () {
      return getSlidesImages(this.projects)
    },
    activeProject () {
      if (!this.flkty || this.slides.length < 1) return false
      const id = this.slides[this.flkty.selectedIndex].id
      return _find(this.projects, ['id', id])
    },
    activeProjectImgCount () {
      if (!this.activeProject || !this.activeProject.body) return -1
      let count = 0
      this.activeProject.body.forEach(slide => {
        const type = slide.slice_type
        if (type === 'diptych') count = count + 2
        else if (type === 'image') count++
      })
      return count
    },
    activeSlide () {
      return this.slides[this.flkty.selectedIndex]
    },
    lastSlideIndexOfFirstPrj () {
      return this.projects[0].body.length - 1
    }
  },
  methods: {
    init () {
      // Initialize Flickity carousel once Projects are loaded
      if (this.projects.length > 0) return this.initCarousel()
      const unwatch = this.$watch('projects', () => {
        this.initCarousel()
        unwatch()
      })
    },
    initCarousel () {
      if (this.flkty) return
      this.flkty = new Flickity(this.$refs.carousel, {
        lazyLoad: 1,
        bgLazyLoad: 1,
        imagesLoaded: true,
        pageDots: false,
        prevNextButtons: false,
        selectedAttraction: 0.02,
        friction: 0.28,
        wrapAround: true,
        on: {
          ready: () => window.addEventListener('keydown', this.onNextKeys)
        }
      })
      // next on static click
      this.flkty.on('staticClick', (event, pointer, cellElement, cellIndex) => {
        if (event.x < cellElement.offsetWidth * 0.33) return this.prevSlide(cellIndex)
        return this.nextSlide(cellIndex)
      })
    },
    jumpToSlide (id) {
      if (!this.flkty) return
      const slideIndex = _findIndex(this.slides, ['id', id])
      if (slideIndex > -1) return this.flkty.select(slideIndex, false, true)
    },
    jumpToSlideByImageSrc (src) {
      if (!src) return
      const index = this.slides.findIndex(slide => slide.urls.includes(src))
      if (index < 0) return
      this.hideThumbsView()
      return this.flkty.select(index, false, true)
    },
    hideThumbsView () {
      window.scrollTo(0, 0)
      this.thumbsVisible = false
    },
    prevSlide (slideIndex) {
      const limitActive = this.limitToFirstPrj && slideIndex === 0
      if (!limitActive) return this.flkty.previous()
    },
    nextSlide (slideIndex) {
      const hitLimit = this.limitToFirstPrj && slideIndex === this.lastSlideIndexOfFirstPrj
      if (hitLimit) return this.$emit('endOfFirstPrj')
      return this.flkty.next()
    },
    onNextKeys (e) {
      const isCarousel = document.activeElement && document.activeElement.classList.contains('carousel')
      if (isCarousel || !this.flkty) return false
      if (e.keyCode === 39) return this.nextSlide(this.flkty.selectedIndex)
      if (e.keyCode === 37) return this.prevSlide(this.flkty.selectedIndex)
    }
  },
  mounted () {
    this.init()
    // this.$emit('heightSet', this.height)
  },
  destroyed () {
    window.removeEventListener('keydown', this.onNextKeys)
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/SeriesViewer__Slider.vue